const tags = [
  { label: '复仇者联盟', hot: true },
  { label: '国产科幻崛起', hot: true },
  { label: '奥斯卡获奖', hot: false },
  { label: '悬疑烧脑', hot: true },
  { label: '经典重映', hot: false },
  { label: '韩影推荐', hot: false },
  { label: 'DC 宇宙', hot: true },
  { label: '动画电影', hot: false },
  { label: '深夜惊悚', hot: true },
  { label: '新片速递', hot: true },
  { label: '独立电影', hot: false },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-hashtag text-secondary-400 text-xs"></i></span>
            <span className="text-xs text-secondary-400 font-medium whitespace-nowrap">话题热榜</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">当下最受影迷关注的热议话题，加入讨论发现更多好片</p>
        </div>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {tags.map((tag) => (
            <a
              key={tag.label}
              href="#topics"
              className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm cursor-pointer transition-all border whitespace-nowrap ${
                tag.hot
                  ? 'bg-accent-500/10 border-accent-500/30 text-accent-300 hover:bg-accent-500/20'
                  : 'bg-background-100 border-background-300/50 text-foreground-300 hover:border-primary-500/30 hover:text-primary-400'
              }`}
            >
              {tag.hot && (
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-fire-fill text-accent-400 text-xs"></i></span>
              )}
              # {tag.label}
              {tag.hot && <span className="text-[10px] text-accent-400 ml-0.5">热</span>}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}